import { i18n } from '@/locales';
export const applyOptionsType = [
    true,
    false,
];
export default applyOptionsType.map((value) => {
    const label = value ? i18n.t('common.apply') : i18n.t('common.not_applied');
    return ({
        label,
        value,
    });
});
